import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import SimilarProduct from './SimilarProduct';
import './SimilarProducts.scss';

function SimilarProducts({ setOpen, dataLocale, products, localeInfo, currencyMark }) {
  const { SIMILAR_PRODUCTS } = dataLocale;

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  });

  useEffect(() => {
    document.getElementsByTagName('html')[0].style.overflow = 'hidden';

    return () => {
      document.getElementsByTagName('html')[0].style.overflow = 'visible';
    };
  }, []);

  return ReactDOM.createPortal(
    <div className="similiar-products-container">
      <div className="similar-products-backdrop" onClick={e => setOpen(e, false)} />
      <div className="similar-products-content animate-left-content">
        <div className="similar-products-header">
          <div className="title">{SIMILAR_PRODUCTS}</div>
          <div className="close-btn">
            <div className="btn" onClick={e => setOpen(e, false)}>
              &times;
            </div>
          </div>
        </div>
        <div className="similiar-product-list">
          {products?.map((item, idx) => (
            <SimilarProduct
              key={item?.id + idx}
              currencyMark={currencyMark}
              dataLocale={dataLocale}
              item={item}
              localeInfo={localeInfo}
            />
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
}

const mapStateToProps = state => ({
  dataLocale: state.locale,
  localeInfo: state.common.localeInfo,
  currencyMark: state.common.currencyMark,
});

export default connect(mapStateToProps)(SimilarProducts);
